import { Grid, Snackbar, Typography } from "@mui/material";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { useStyles } from "./WarningToastStyle";
import React, { useState } from "react";

interface WarningToastProps {
  open: boolean;
}
export const WarningToast = ({ open }: WarningToastProps) => {
  const classes = useStyles();
  const [warning, setWarning] = useState<boolean>(open);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setWarning(false);
  };

  const Warning = (
    <React.Fragment>
      <Grid container sx={{ width: '270px', height: '100px' }}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <WarningRoundedIcon />
          <Typography>WARNING</Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography>Virus attack on the system!</Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );

  return (
    <>
      <Snackbar
        className={classes.msgAlignment}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={warning}
        // autoHideDuration={3000}
        message={Warning}
        onClose={handleClose}
      />
    </>
  )
};